import { Autocomplete, Button, FormControl, Grid, TextField, Typography, Link } from "@mui/material";
import { formatDate } from "helpers/dates";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { generateLines } from "store/slice/linesGeneration";

const { default: ModalAbstract } = require("common/Modal/Modal");

const GenerationModal = ({ isOpen, handleModalClose, onSubmit }) => {
    const store = useSelector((store) => store.linesGeneration);
    let shifts = store?.shifts || [];
    const dispatch = useDispatch();

    shifts = shifts.map(cur => {
        return {id: cur.id, label: formatDate(cur?.startDate) + ' - ' + formatDate(cur?.endDate) }
    })
    const [shift, setShift] = useState(null);
    const [touched, setTouched] = useState(false);

    const error = useMemo(() => {
        if (!touched) return "";
        if (!shift) return "Shift is required";
        return "";
    }, [touched, shift]);

    const handleGenerate = () => {
        setTouched(true);

        if (!shift) return;

        if (onSubmit) onSubmit({ shiftId: shift.id, shift });
        
        handleModalClose();
        dispatch(generateLines({shiftId: parseInt(shift.id)}))
        
        setShift(null);
        setTouched(false);
    };

  const handleClose = () => {
    handleModalClose();
    setShift(null);
    setTouched(false);
  };
  return (
    <ModalAbstract open={isOpen} onClose={handleClose}>
      <Typography variant="h5" component="h2" gutterBottom>
        Generate rotation
      </Typography>

      <Grid container spacing={2}>
        <Grid item size={{xs: 12}}>
        {store?.generations?.length < shifts.length ? 
          <FormControl fullWidth error={Boolean(error)}>
            <Autocomplete
              options={shifts}
              value={shift}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              getOptionLabel={(option) => option?.label ?? ""}
              onChange={(event, value) => {
                setShift(value);
                setTouched(true);
              }}
              onBlur={() => setTouched(true)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Shift"
                  name="shift"
                  error={Boolean(error)}
                  helperText={error}
                />
              )}
            />
            </FormControl>: 
            <Typography>
                No shifts found.{" "}
                <Link
                    component={RouterLink}
                    to="/shiftGeneration"
                    underline="always"
                    color="primary"
                    sx={{
                        cursor: "pointer",
                        fontWeight: 600,
                    }}
                >
                    Create a shift
                </Link>
            </Typography>}
        </Grid>

        <Grid item size={{xs: 12}} display="flex" gap={1} justifyContent="flex-end">
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleGenerate}>
            Generate
          </Button>
        </Grid>
      </Grid>
    </ModalAbstract>
  );
};

export default GenerationModal;
